// extracted by mini-css-extract-plugin
export var active = "slider-module--active--Q59BV";
export var buttonBox = "slider-module--button-box--ruqRi";
export var container = "slider-module--container--6Wmz5";
export var dots = "slider-module--dots--ahg6X";
export var next = "slider-module--next--X7qXu";
export var prev = "slider-module--prev--6IgS1";
export var slickList = "slider-module--slick-list--4QwqF";
export var slide = "slider-module--slide--yiSk2";
export var sliderNav = "slider-module--slider-nav--bJHj9";